var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const getTrackingData = ({
  isTrackContent,
  contentName,
  index,
  regionName,
  target,
  payload
}) => {
  return __spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues({}, regionName && { "data-content-region-name": regionName }), isTrackContent && { "data-track-content": true }), contentName && { "data-content-name": contentName }), (index || index === 0) && { "data-content-index": index }), target && { "data-content-target": target }), payload && { "data-content-payload": payload });
};
const trackCustomEvent = (eventName, payload) => {
  return window.track("customEvent", eventName, payload);
};
const trackLinkClicked = (eventName, payload) => {
  return window.track("linkClick", eventName, payload);
};
const trackVisibleManually = ({
  regionName,
  contentName,
  index,
  payload
}) => {
  return window.track("manualTrackVisibleContentImpressions", {
    regionName,
    contentName,
    payload,
    index
  });
};

export { getTrackingData, trackCustomEvent, trackLinkClicked, trackVisibleManually };
